<template>
  <div>
    <h6 class="text-h6 black--text">Items de Formula</h6>
    <p class="text-body-2">Ingrese los items de la formula</p>

    <v-row>
      <v-col md="12" v-if="!isViewModal">
        <v-btn small color="blue-grey" class="pl-4 text-white" @click="newItem">
          <v-icon big color="green"> add </v-icon>
          <span>Agregar item</span>
        </v-btn>
      </v-col>

      <v-col md="12" class="px-4 pb-4">
        <v-data-table :headers="header_items" :items="formula.items" style="border: solid 1px #1c1c1c" :hide-default-footer="true" :items-per-page="100">
          <template v-slot:item="props">
            <tr>
              <td>{{ props.item.orden_secuencia }}</td>
              <td>{{ getTypeText(props.item.type.id) }}</td>
              <td>{{ getDescription(props.item) }}</td>
              <td>{{ props.item.valor }}</td>
              <td>{{ getStorageUnit(props.item) }}</td>
              <td>{{ props.item.observacion || '-' }}</td>
              <td class="text-center" style="width: 80px">
                <v-tooltip bottom v-if="!isViewModal">
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" small color="blue" class="mr-2" @click="editFormulaItem(props.item)"> edit </v-icon>
                  </template>
                  <span>Editar</span>
                </v-tooltip>
                <v-tooltip bottom v-if="!isViewModal">
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" small color="red" @click="removeItem(props.item)"> indeterminate_check_box </v-icon>
                  </template>
                  <span>Remover</span>
                </v-tooltip>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <!-- START FORM DIALOG -->
    <ModalFormulaItem :dialog="dialog_item" :itemEdit="itemEdit" :formula="formula" @updateDialog="dialog_item = false" @addItem="addItem" />
  </div>
</template>

<script>
import Vue from "vue";
import ModalFormulaItem from "./ModalFormulaItem.vue";
import { FORMULA_ITEM_TYPE_CONFIG as TYPE_CONFIG } from "@/constants/formulaItemTypes";

export default {
  created() {
    this.$validator = this.validator;
  },
  components: { ModalFormulaItem },
  props: {
    open: Boolean,
    formula: Object,
    validator: Object,
    isViewModal: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    header_items: [
      { text: "Orden", value: "orden_secuencia", sortable: true },
      { text: "Tipo", value: "type", sortable: false },
      { text: "Descripción", value: "descripcion", sortable: false },
      { text: "Cantidad", value: "valor", sortable: false },
      { text: "Unidad", value: "storage_unit", sortable: false },
      { text: "Observación", value: "observacion", sortable: false },
      { text: "Accion", value: "", sortable: false },
    ],
    dialog_item: false,
    itemEdit: null,
    itemEditIndex: null,
  }),
  watch: {
    open: function (val) {
      if (val) {
        this.errors.clear();
        this.$validator.reset();
      }
    },
    formula: {
      handler: function (newValue) {},
      deep: true,
    },
  },
  mounted() {},
  methods: {
    getTypeText(type) {
      return TYPE_CONFIG[type]?.name || type;
    },
    getDescription(item) {
      const typeId = item.type.id || item.type;
      const config = TYPE_CONFIG[typeId];
      if (!config) return '';
      
      const entity = item[config.entityKey];
      return entity?.label || entity?.name || '';
    },
    getStorageUnit(item) {
      const typeId = item.type.id || item.type;
      const config = TYPE_CONFIG[typeId];
      if (!config || !config.unitKey) return '-';
      
      const entity = item[config.entityKey];
      const unit = entity?.[config.unitKey];
      return unit?.name || '-';
    },
    newItem() {
      this.itemEdit = null;
      this.itemEditIndex = null;
      this.dialog_item = true;
    },
    editFormulaItem(item) {
      this.itemEditIndex = this.formula.items.indexOf(item);
      this.itemEdit = Object.assign({}, item);
      this.dialog_item = true;
    },
    addItem(item) {
      if (this.itemEditIndex == null) {
        this.formula.items.push(item);
      } else {
        //para que detecte el cambio
        Vue.set(this.formula.items, this.itemEditIndex, item);
      }
      this.dialog_item = false;
    },
    removeItem(item) {
      const index_item = this.formula.items.indexOf(item);
      if (index_item > -1) this.formula.items.splice(index_item, 1);
    },
  },
};
</script>
